module.exports = __webpack_public_path__ + "img/primar-textlogo.d6458367.png";